import { render } from "./InputNumberPercentage.vue?vue&type=template&id=67c8e904"
import script from "./InputNumberPercentage.vue?vue&type=script&lang=js"
export * from "./InputNumberPercentage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__